var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('user-form',{attrs:{"user":_vm.user},on:{"onUserSave":_vm.saveUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }